export default __webpack_public_path__ + "static/media/roundBallIcon.d39ba4a6.svg";